import admin from "./admin_logs";
import admin_links from "./admin_links";
export default [
  ...admin,
  ...admin_links,
  {},
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: () => import("../views/auth/register.vue"),
  //   meta: {
  //     title: "Register",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  // {
  //   path: "/forgot-password",
  //   name: "Forgot password",
  //   component: () => import("../views/auth/forgot-password.vue"),
  //   meta: {
  //     title: "Forgot Password",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  // {
  //   path: "/dashboard",
  //   name: "dashboard",
  //   meta: {
  //     title: "Dashboard",
  //     authRequired: true,
  //     acc: "",
  //   },
  //   component: () => import("../views/dashboard/student-dashboard.vue"),
  // },

  // start of 404
  // {
  //   path: "/notfound",
  //   name: "notfound",
  //   meta: {
  //     title: "404",
  //     //
  //   },
  //   component: () => import("../views/notfound/404-cover"),
  // },
  // end of 404
];
